// extracted by mini-css-extract-plugin
module.exports = {"mockPaypalButton":"_2zwJO","loader":"_2G_v_"};